import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Hero: React.FC = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <section className="relative min-h-screen h-[108vh] flex items-center justify-center overflow-hidden">
      {/* Background image - dynamically chosen based on screen size */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: isMobile ? 'url(/hero-background-mobile.jpg)' : 'url(/hero-background.jpg)',
          width: '100vw', 
          left: '50%', 
          transform: 'translateX(-50%)' 
        }} 
      />
      
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/40" />
      
      {/* Red gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-900/30 via-red-800/20 to-red-900/30" />
      
      {/* Bottom fade transition */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white via-white/50 to-transparent" />

      <div className="relative z-10 text-center section-padding max-w-6xl mx-auto">
        <div className="mb-8 animate-fadeInUp">
          <div className="h-px bg-white mx-auto mb-8 w-24" />
          
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <Logo width={120} height={120} className="md:w-40 md:h-40 shadow-xl rounded-full" />
          </div>
          
          <p className="text-white/90 text-lg tracking-luxury uppercase font-body mb-1 md:mb-3">
            {t('hero.experience')}
          </p>
        </div>

        <h1 className="text-display-xl md:text-6xl lg:text-7xl xl:text-8xl font-display mb-8 animate-fadeInUp animation-delay-200 text-white px-2">
                      ROYAL <span className="text-red-300">O'NARA</span>
          <br />
          <span className="text-red-300 text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl block mt-1 md:mt-0">PONTARLIER</span>
        </h1>
        
        <p className="text-xl md:text-2xl lg:text-3xl mb-12 font-body font-light text-white/90 max-w-3xl mx-auto leading-relaxed animate-fadeInUp animation-delay-400">
          {t('hero.subtitle')}
        </p>

        <div className="animate-scaleIn animation-delay-600 flex justify-center">
          <Link to="/menu">
            <button className="relative inline-block px-10 py-5 overflow-hidden transition-all duration-500 bg-koi-red text-white border-2 border-koi-red hover:bg-white hover:text-koi-red font-display tracking-wider uppercase text-sm group">
              <span className="relative z-10">{t('hero.cta')}</span>
              <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </button>
          </Link>
        </div>
      </div>

    </section>
  );
};

export default Hero;